import React from 'react';
import './App.css';
import { Footer } from './componets/footer/footer';
import { Parallax } from './componets/parallax/parallax';
import { Header } from './componets/header/header';
import { Main } from './componets/main/main';
// import  {Page404}  from './componets/page404/page404';

const App = () => {
  return (
    <div className='App'>
      <Parallax />
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
